module.exports = __webpack_public_path__ + "img/mercedes-amg-logo-mark.cddab74b.jpg";